// extracted by mini-css-extract-plugin
export default {"container":"whatsapp-button_container__84J20","icon":"whatsapp-button_icon__s8xH6"};